import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  public url: any;
  public urlUser: any;
  public token: any | null;
  public headers: HttpHeaders;

  constructor(private _http: HttpClient) {
    this.url = `${GLOBAL.url}/usertagcategory/`;
    this.urlUser = `${GLOBAL.url}/usertagcategorypermission/`;
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  create(json: any): Observable<any> {
    return this.petition(`${this.url}new?page=1`, json);
  }

  update(json: any, id: any): Observable<any> {
    return this.petition(`${this.url}edit/${id}?page=1`, json);
  }

  showOne(id: any): Observable<any> {
    return this.petition(`${this.url}detail/${id}?page=1`);
  }

  showAll(type: any | null = null): Observable<any> {
    let url = `${this.url}list`;
    if (type !== null) {
      url += `/${type}`;
    }
    return this.petition(`${url}?page=1`);
  }

  delete(id: any): Observable<any> {
    return this.petition(`${this.url}remove/${id}?page=1`);
  }

  petition(url: any, json: any | null = null, type: any | null = null): Observable<any> {

    this.token = JSON.parse(localStorage.getItem('token'));
    
   let params;
    params = `authorization=${this.token}`;

    if (json != null) {
      json = JSON.stringify(json);
      params = params + '&json=' + json;
    }

    if (type != null) {
      params = params + '&type=' + type;
    }
    console.log("petition params => ", params);
    return this._http.post(
      url,
      params,
      { headers: this.headers }
    ).pipe(
      map(res => res)
    );
  }

  linkUserCategories(json: any): Observable<any> {
    return this.petition(`${this.urlUser}new?page=1`, json);
  }

  getUserCategories(id: any): Observable<any> {
    return this.petition(`${this.urlUser}listbyfather/${id}?page=1`);
  }

  updateUserCategories(json: any, id: any): Observable<any> {
    return this.petition(`${this.urlUser}edit/${id}?page=1`, json);
  }

  listUserCategories(json: any): Observable<any> {
    return this.petition(`${this.urlUser}listbycategory?page=1`, json);
  }
}